module.exports = __webpack_public_path__ + "asset/image-ic_category_26-2d1ea1b2d887c81d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_26.svg
// module id = Nfcd
// module chunks = 0